
<template>
  <div class="modalback">
    <div class="modalcontent">
      <div class="close cursor-pointer"><img src="@/assets/acrypro/close.svg" @click="closeAction"/></div>
      <p class="fw-bold" style="font-size: 28px;">プレビュー</p>
      <img class="imageViewer m-auto" :src="this.$store.state.previewImageArray[0]" />
    </div>
  </div>
</template>
<script>


export default {
  name: "ImagePreviewPopupAp",
  props: {},
  data: function () {
    return {
    };
  },
  mounted: function () {
  },
  computed: {
    // styleVariables() {
    //   return {
    //     "background-image": 'url("' + this.$store.state.previewImageArray[0] + '"',
    //   };
    // },
  },
  methods: {
    closeAction(){
      this.$store.commit("hideImagePreview")
    }
  },
  components: {
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.modalback {
  z-index: 200;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modalcontent {
  position: relative;
  z-index: 201;
  width: 1190px;
  height: 600px;
  padding: 40px;
  background-color: $background-white-color;
  // border-radius: 8px;
}
.close {
  position: absolute;
  width: 48px;
  right: 40px;
}
.imageViewer{
  width: 272px;
  background-repeat: round;
  background-size: cover;
  border: 1px solid;
}
</style>
